import { Injectable } from '@angular/core';
import { Subject, Observable }    from 'rxjs';

import { CustomerModel, initCustomerModel } from '../../../core'

@Injectable()
export class CustomersStateService {

  private selectedCustomerChanged = new Subject<CustomerModel>();
  private customerUpdated = new Subject<CustomerModel>();
  private customerBusy = new Subject<boolean>();
  private refreshCustomerHere = new Subject<{}>();

  selectedCustomer:Observable<CustomerModel> ;
  updatedCustomer:Observable<CustomerModel>  ;
  busy:Observable<boolean>;
  refreshCustomer:Observable<{}>;
  constructor() { 
    this.selectedCustomer = this.selectedCustomerChanged.asObservable();
    this.updatedCustomer = this.customerUpdated.asObservable();
    this.busy = this.customerBusy.asObservable();
    this.refreshCustomer = this.refreshCustomerHere.asObservable();
  }

  customerSelected(customer: CustomerModel ){
    this.selectedCustomerChanged.next(customer);
  }

  customerUpdate(customer: CustomerModel){
    this.customerUpdated.next(customer)
  }

  setBusy(busy: boolean){
    this.customerBusy.next(busy);
  }

  customerRefresh(){
    this.refreshCustomerHere.next({});
  }
}
